import { useTheme } from "@emotion/react";
import { Box, Button, Stack, Typography, useMediaQuery } from "@mui/material";
import LINKS from "../Navbar/constants";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

const Menu = ({ isMenuVisible, setIsMenuVisible }) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  if (!md)
    return (
      <>
        <Stack
          className={isMenuVisible ? "pop-in" : "pop-out"}
          sx={{
            position: "fixed",
            top: 0,
            background: "#000",
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 99,
            transition: "all ease 0.3s",
          }}
        >
          <Stack m="auto" spacing={2} alignSelf="center" textAlign="center">
            {LINKS.map(({ path, title }, idx) => (
              <HashLink
                key={idx}
                style={{
                  textDecoration: "none",
                }}
                onClick={() => setIsMenuVisible(false)}
                to={path}
              >
                <Typography
                  sx={{ opacity: 0.5, "&:hover": { opacity: 1 } }}
                  variant="h3"
                  color="white"
                >
                  {title}
                </Typography>
              </HashLink>
            ))}
          </Stack>
          <Box mb={4} width="90%" mx="auto">
            <Link to="/contact">
              <Box onClick={() => setIsMenuVisible(false)}>
                <Button
                  color="white"
                  size="large"
                  variant="contained"
                  fullWidth
                >
                  Contact us
                </Button>
              </Box>
            </Link>
          </Box>
        </Stack>
      </>
    );
};

export default Menu;
